import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/posys-logo-small.png'


const _withScopeId = n => (_pushScopeId("data-v-ec9da298"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-img"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-txt" }, "T.", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "fs-btn-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Txt-btn bigLetter" }, "B", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Txt-btn bigLetter" }, [
  /*#__PURE__*/_createElementVNode("i", null, "I")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Txt-btn bigLetter underline" }, "U", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Txt-btn" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bigLetter" }, "T"),
  /*#__PURE__*/_createTextVNode(" T ")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "img-setting-pop" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Opacity : ", -1))
const _hoisted_15 = { class: "tool-btn" }
const _hoisted_16 = { class: "tool-btn" }
const _hoisted_17 = { class: "edit-color-btn" }
const _hoisted_18 = { class: "edit-color-btn" }
const _hoisted_19 = { class: "preview-wrapper" }
const _hoisted_20 = { class: "tools-container-small" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-txt" }, "T.", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onMousedown", "onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "pdf-overlay",
  ref: "pdfOverlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_MinusOutlined = _resolveComponent("MinusOutlined")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_AlignLeftOutlined = _resolveComponent("AlignLeftOutlined")!
  const _component_AlignCenterOutlined = _resolveComponent("AlignCenterOutlined")!
  const _component_AlignRightOutlined = _resolveComponent("AlignRightOutlined")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_VerticalAlignMiddleOutlined = _resolveComponent("VerticalAlignMiddleOutlined")!
  const _component_FileImageOutlined = _resolveComponent("FileImageOutlined")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_BgColorsOutlined = _resolveComponent("BgColorsOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_button_group = _resolveComponent("a-button-group")!
  const _component_QrcodeOutlined = _resolveComponent("QrcodeOutlined")!
  const _component_a_qrcode = _resolveComponent("a-qrcode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: "logo-container",
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 12},
          lg: { span: 12 },
          xl: { span: 12 },
          xxl: { span: 12 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
              class: "back-btn"
            }, [
              _createVNode(_component_HomeOutlined, { class: "back-icon" })
            ]),
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "action-img-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: "action-img-container",
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 24 },
          xl: { span: 24 },
          xxl: { span: 24 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSize('A4'))),
                  class: "size-btn"
                }, "A4"),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSize('A5'))),
                  class: "size-btn"
                }, "A5"),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSize('A6'))),
                  class: "size-btn"
                }, "A6")
              ]),
              _: 1
            }),
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("Pos.Download")), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadPdf && _ctx.downloadPdf(...args))),
                  class: "action-btn action-btn-right"
                }, [
                  _createVNode(_component_DownloadOutlined, { class: "export-icon" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "tools-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: "tools-container",
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 24 },
          xl: { span: 24 },
          xxl: { span: 24 }
        }, {
          default: _withCtx(() => [
            (_ctx.openTxt)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "tool-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addText && _ctx.addText(...args)))
                  }, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "font-size-btn",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.decreaseFontSize && _ctx.decreaseFontSize(...args)))
                    }, [
                      _createVNode(_component_MinusOutlined, { class: "fs-icon" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fontSizeInput) = $event)),
                      class: "font-size-input"
                    }, null, 512), [
                      [_vModelText, _ctx.fontSizeInput]
                    ]),
                    _createElementVNode("button", {
                      class: "font-size-btn",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.increaseFontSize && _ctx.increaseFontSize(...args)))
                    }, [
                      _createVNode(_component_PlusOutlined, { class: "fs-icon" })
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["fw-btn", {'selected':_ctx.selectedElement.fontWeight === 'bold'}]),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleBold && _ctx.toggleBold(...args)))
                  }, _hoisted_6, 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["fw-btn", {'selected':_ctx.selectedElement.fontStyle === 'italic'}]),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleItalic && _ctx.toggleItalic(...args)))
                  }, _hoisted_8, 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["fw-btn", {'selected':_ctx.selectedElement.textDecoration === 'underline'}]),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleUnderline && _ctx.toggleUnderline(...args)))
                  }, _hoisted_10, 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["fw-btn", {'selected':_ctx.selectedElement.textTransform === 'uppercase'}]),
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toggleUpper && _ctx.toggleUpper(...args)))
                  }, _hoisted_12, 2),
                  _createElementVNode("div", {
                    class: "edit-color-btn",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.toggleColorPicker && _ctx.toggleColorPicker(...args)))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "color",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.color) = $event)),
                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.updateColor && _ctx.updateColor(...args))),
                      class: "color-picker"
                    }, null, 544), [
                      [_vModelText, _ctx.state.color]
                    ]),
                    _createVNode(_component_EditOutlined, {
                      class: "edit-icon",
                      style: _normalizeStyle({ color: _ctx.iconColor })
                    }, null, 8, ["style"])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.deleteElement && _ctx.deleteElement(...args))),
                    class: "tool-btn"
                  }, [
                    _createVNode(_component_DeleteOutlined, { class: "delete-elet-icon" })
                  ]),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tool-btn", {'selected':_ctx.selectedElement.textAlign === 'start'}]),
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleStartAlign && _ctx.toggleStartAlign(...args)))
                  }, [
                    _createVNode(_component_AlignLeftOutlined, { class: "edit-icon" })
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tool-btn", {'selected':_ctx.selectedElement.textAlign === 'center'}]),
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleCenterAlign && _ctx.toggleCenterAlign(...args)))
                  }, [
                    _createVNode(_component_AlignCenterOutlined, { class: "edit-icon" })
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tool-btn", {'selected':_ctx.selectedElement.textAlign === 'end'}]),
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleEndAlign && _ctx.toggleEndAlign(...args)))
                  }, [
                    _createVNode(_component_AlignRightOutlined, { class: "edit-icon" })
                  ], 2),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createVNode(_component_a_select, {
                    value: _ctx.fontFam,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.fontFam) = $event)),
                    options: _ctx.fontFamilies,
                    "field-names": { label: 'label', value: 'value' },
                    style: {"width":"200px"},
                    onSelect: _ctx.toggleFontFam
                  }, null, 8, ["value", "options", "onSelect"]),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.adjustElement(_ctx.element)))
                  }, [
                    _createVNode(_component_VerticalAlignMiddleOutlined, { class: "edit-icon" })
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.openPhoto)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: "file-upload-btn",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args)))
                  }, [
                    _createVNode(_component_FileImageOutlined, { class: "img-icon tool-icon" })
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    ref: "fileInput",
                    class: "file-input",
                    onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                  }, null, 544),
                  _createVNode(_component_a_popover, {
                    open: _ctx.imgConfig,
                    "onUpdate:open": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.imgConfig) = $event)),
                    trigger: "click"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_a_slider, {
                            value: _ctx.state.opacity,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.opacity) = $event)),
                            class: "slider-input",
                            onAfterChange: _ctx.handleOpacityChange
                          }, null, 8, ["value", "onAfterChange"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_15, [
                        _createVNode(_component_SettingOutlined, { class: "img-icon" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createElementVNode("div", {
                    class: "edit-color-btn",
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.toggleColorPickerBg && _ctx.toggleColorPickerBg(...args)))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "color",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.bgColor) = $event)),
                      onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.updateBgColor && _ctx.updateBgColor(...args))),
                      class: "color-picker-bg"
                    }, null, 544), [
                      [_vModelText, _ctx.state.bgColor]
                    ]),
                    _createVNode(_component_BgColorsOutlined, {
                      class: "edit-icon",
                      style: _normalizeStyle({ color: _ctx.iconColorBg })
                    }, null, 8, ["style"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.openQr)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_a_popover, {
                    open: _ctx.visible,
                    "onUpdate:open": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.visible) = $event)),
                    trigger: "click"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.url,
                        "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.url) = $event)),
                        placeholder: _ctx.t('Pos.urlPlaceholder'),
                        maxlength: 60
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_16, [
                        _createVNode(_component_LinkOutlined, { class: "img-icon" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "color",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.qrColor) = $event)),
                      class: "color-picker-qr"
                    }, null, 512), [
                      [_vModelText, _ctx.state.qrColor]
                    ]),
                    _createVNode(_component_EditOutlined, {
                      class: "edit-icon",
                      style: _normalizeStyle({ color: _ctx.iconColorQR })
                    }, null, 8, ["style"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "color",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.qrBg) = $event)),
                      class: "color-picker-qr-bg"
                    }, null, 512), [
                      [_vModelText, _ctx.state.qrBg]
                    ]),
                    _createVNode(_component_BgColorsOutlined, {
                      class: "edit-icon",
                      style: _normalizeStyle({ color: _ctx.iconColorQRBg })
                    }, null, 8, ["style"])
                  ]),
                  _createVNode(_component_a_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        onClick: _ctx.decline,
                        class: "size-btn"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_MinusOutlined)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: _ctx.increase,
                        class: "size-btn"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_PlusOutlined)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: _normalizeClass(["tool-btn", {'selected':_ctx.openTxt===true}]),
          onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.configTxt && _ctx.configTxt(...args)))
        }, _hoisted_22, 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tool-btn", {'selected':_ctx.openPhoto===true}]),
          onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.configBg && _ctx.configBg(...args)))
        }, [
          _createVNode(_component_FileImageOutlined, { class: "img-icon" })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tool-btn", {'selected':_ctx.openQr===true}]),
          onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.configQr && _ctx.configQr(...args)))
        }, [
          _createVNode(_component_QrcodeOutlined, { class: "img-icon" })
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['preview-container', _ctx.selectedSize]),
        ref: "previewContainer",
        style: _normalizeStyle(_ctx.previewContainerStyle)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "draggable",
            style: _normalizeStyle(_ctx.getElementStyle(element)),
            onMousedown: ($event: any) => (_ctx.startDrag($event, element)),
            onClick: ($event: any) => (_ctx.selectElement(element))
          }, [
            (element.type === 'text')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  contenteditable: "true",
                  class: "elet",
                  onClick: ($event: any) => (_ctx.selectElement(element))
                }, _toDisplayString(element.content), 9, _hoisted_24))
              : _createCommentVNode("", true)
          ], 44, _hoisted_23))
        }), 128)),
        _createElementVNode("div", {
          ref: "qrCodeContainer",
          style: _normalizeStyle(_ctx.qrCodeStyle)
        }, [
          _createVNode(_component_a_qrcode, {
            size: _ctx.qrSize,
            value: _ctx.url,
            onMousedown: _ctx.startDragQr,
            color: _ctx.state.qrColor,
            "bg-color": _ctx.state.qrBg
          }, null, 8, ["size", "value", "onMousedown", "color", "bg-color"])
        ], 4)
      ], 6),
      (_ctx.generatingPdf)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, null, 512))
        : _createCommentVNode("", true)
    ])
  ], 64))
}